import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  connectAuthEmulator,
  type Auth,
} from "firebase/auth";
import {
  getFirestore,
  connectFirestoreEmulator,
  type Firestore,
} from "firebase/firestore";
import {
  getFunctions,
  connectFunctionsEmulator,
  type Functions,
} from "firebase/functions";

// Firebase Storage queda fuera a propósito: el bucket default de Firebase
// Storage no está aprovisionado en este proyecto (todo el binario va al
// bucket GCS custom `WORKSPACES_BUCKET` accedido server-side via Admin SDK).
// Si en el futuro se necesita upload directo desde browser, hay que crear el
// bucket default + reglas + reintroducir el SDK aquí — pero hasta entonces
// el handle solo era una puerta abierta a confusión y a una superficie de
// ataque innecesaria.

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const isFirebaseEnabled = !!(
  firebaseConfig.apiKey && firebaseConfig.projectId
);

const app: FirebaseApp | null = isFirebaseEnabled
  ? getApps()[0] ?? initializeApp(firebaseConfig)
  : null;

export const auth: Auth | null = app ? getAuth(app) : null;
export const db: Firestore | null = app ? getFirestore(app) : null;
export const functions: Functions | null = app
  ? getFunctions(app, "europe-west1")
  : null;
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

if (
  typeof window !== "undefined" &&
  import.meta.env.VITE_USE_EMULATORS === "true" &&
  auth &&
  db &&
  functions
) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  // eslint-disable-next-line no-console
  console.info("[firebase-admin] Using emulators");
}

export type { DbProfile, UserRole, AccountType } from "./types";
